import Footer from '@/pages/footer';
import Header from '@/pages/header'
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useEffect, useState } from 'react'
import styles from "../../../../styles/DocumentDetail.module.css"
import Link from 'next/link';
import SwiperArrow from '@/pages/images/swiperArrow';
import PortalLaptop from '@/pages/images/portalLaptop';
import NotificationPortal from '@/pages/images/notificationPortal';
import Theme from '@/pages/images/theme';
import { useTranslation } from 'next-i18next';
import LoginMethod from '@/pages/images/loginMethod';
import { useRouter } from 'next/router';
import PageSeo from '@/components/seo/PageSeo';

const markDocumentAsViewed = (documentId: number) => {
  if (typeof window !== "undefined") {
    let viewedDocuments = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
    if (!viewedDocuments.includes(documentId)) {
      viewedDocuments.push(documentId);
      localStorage.setItem('serviceManagementViewedDocuments', JSON.stringify(viewedDocuments));
    }
  }
};

interface ServiceDocumentStep {
  id: number;
  icon: React.ComponentType<{ color?: string }>;
  docNumber: string;
  title: string;
  link: string;
}

const ContentTheme = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation("documentsTranslate");
  const router = useRouter();
  const [viewedDocuments, setViewedDocuments] = useState<number[]>([]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const viewed = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(viewed);
      markDocumentAsViewed(3);
      // Update state after marking as viewed
      const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(updated);
    }
  }, []);

  const serviceDocumentStep: ServiceDocumentStep[] = [
    {
      id: 1,
      icon: PortalLaptop,
      docNumber: 'Doc 1',
      title: `${t("serviceManagementDocPortalTitle")}`,
      link: '/service-management/documents/portal'
    },
    {
      id: 2,
      icon: LoginMethod,
      docNumber: 'Doc 2',
      title: `${t("serviceManagementDocLoginMethodTitle")}`,
      link: '/service-management/documents/login-method'
    },
    {
      id: 3,
      icon: Theme,
      docNumber: 'Doc 3',
      title: `${t("serviceManagementDocThemeTitle")}`,
      link: '/service-management/documents/content-theme'
    },
    {
      id: 4,
      icon: NotificationPortal,
      docNumber: 'Doc 4',
      title: `${t("serviceManagementDocPortalNotificationTitle")}`,
      link: '/service-management/documents/notification'
    }
  ]

  return (
    <>
      <PageSeo
        title={`${t("serviceManagementDocThemeTitle")} | Stoneity`}
        description={t("serviceManagementDocThemeDescriptionOne")}
        locale={router.locale}
        keywords={router.locale === "tr"
          ? "tema yönetimi dokümanı, arayüz teması, Stoneity"
          : "theme management document, interface theme, Stoneity"
        }
      />
      <Header />
      <div className={styles.pageFlex}>
        <div className={styles.documentDetailWrapper}>
          <div className={styles.stepWrapper}>
            {serviceDocumentStep.map((docStep, index) => {
              const isDocViewed = viewedDocuments.includes(docStep.id);
              const IconComponent = docStep.icon;
              return (
                <Link key={index} href={docStep.link} className={styles.stepperItem} style={{ width: "auto", flex: "1 1" }} onClick={() => {
                  markDocumentAsViewed(docStep.id);
                  const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
                  setViewedDocuments(updated);
                }}>
                  <div className={`${styles.stepIconWrapper} ${isDocViewed ? styles.completed : ""}`}>
                    {IconComponent && <IconComponent color={isDocViewed ? "#fff" : "#03555E"} />}
                  </div>
                  <div className={styles.stepName}>{docStep.title}</div>
                  <div className={styles.stepDoc}>{docStep.docNumber}</div>
                </Link>
              )
            })}
          </div>
          <div className={styles.documentDetailTop}>
            <div className={styles.responsiveDocumentCounter}>Doc 3</div>
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/login-method'} style={{ transform: "rotate(180deg)" }}><SwiperArrow /></Link>
            {t("serviceManagementDocThemeTitle")}
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/notification'}><SwiperArrow /></Link>
          </div>
          <div className={styles.documentDetailPortalBottomWrapper}>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("whatIs")}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div className={styles.explain}>{t("serviceManagementDocThemeDescriptionOne")}</div>
                <div className={styles.explain}>{t("serviceManagementDocThemeSubtaskTitle")}:</div>
                <div>
                  <div className={styles.explainWrapper}>
                    <span>{t("serviceManagementDocLoginHowToUseColumnSubtaskTextTitleOne")}:</span>
                    {t("serviceManagementDocThemeSubtaskColumnExplainOne")}
                  </div>
                  <div className={styles.explainWrapper}>
                    <span>{t("serviceManagementDocThemeSubtaskColumnTitleTwo")}:</span>
                    {t("serviceManagementDocThemeSubtaskColumnExplainTwo")}
                  </div>
                </div>
                <div className={styles.explain}>{t("serviceManagementDocThemeDescriptionTwo")}</div>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("howToUse")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeHowToUseDescriptionOne")}</div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("serviceManagementDocThemeSubtaskTitleOne")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeSubtaskDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <div className={styles.subtaskTitle}>{t("serviceManagementDocThemeSubtaskRowTitleOne")}:</div>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocThemeSubtaskRowDescriptionTitleOne")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainOne")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainTwo")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainThree")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeSubtaskRowDescriptionTitleTwo")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainFour")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainFive")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainSix")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeSubtaskRowDescriptionTitleThree")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainSeven")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainEight")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeSubtaskRowDescriptionTitleFour")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainNine")}</li>
                      <li>{t("serviceManagementDocThemeSubtaskRowDescriptionExplainTen")}</li>
                    </ul>
                  </li>
                </ul>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.explain}>{t("serviceManagementDocThemeSubtaskDescriptionTwo")}</div>
                </div>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("homepage")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeHomePageDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <div className={styles.title}>{t("serviceManagementDocThemeHomePageSubtaskTitleOne")}</div>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocThemeHomePageSubtaskDescriptionTitleOne")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainOne")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainTwo")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainThree")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeHomePageSubtaskDescriptionTitleTwo")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainFour")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainFive")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeHomePageSubtaskDescriptionTitleThree")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainSix")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainSeven")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainEight")}</li>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainNine")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeHomePageSubtaskDescriptionTitleFour")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeHomePageSubtaskDescriptionExplainTen")}</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("serviceManagementDocThemeGuideSubtaskTitleOne")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeGuideSubtaskDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocThemeGuideSubtaskDescriptionTitleOne")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeGuideSubtaskDescriptionExplainOne")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeGuideSubtaskDescriptionTitleTwo")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeGuideSubtaskDescriptionExplainTwo")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeGuideSubtaskDescriptionTitleThree")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeGuideSubtaskDescriptionExplainThree")}</li>
                    </ul>
                  </li>
                </ul>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.explain}>{t("serviceManagementDocThemeGuideSubtaskDescriptionTwo")}</div>
                </div>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("serviceManagementDocThemeServiceSubtaskTitleOne")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeServiceSubtaskDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocThemeServiceSubtaskDescriptionTitleOne")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeServiceSubtaskDescriptionTextOne")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeServiceSubtaskDescriptionTitleTwo")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeServiceSubtaskDescriptionTextTwo")}</li>
                      <li>{t("serviceManagementDocThemeServiceSubtaskDescriptionTextThree")}</li>
                      <li>{t("serviceManagementDocThemeServiceSubtaskDescriptionTextFour")}</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("serviceManagementDocThemeInformationSubtaskTitleOne")}</div>
              <div className={styles.explain}>{t("serviceManagementDocThemeInformationSubtaskDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocThemeInformationSubtaskDescriptionTitleOne")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextOne")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeInformationSubtaskDescriptionTitleTwo")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextTwo")}</li>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextThree")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeInformationSubtaskDescriptionTitleThree")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextFour")}</li>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextFive")}</li>
                    </ul>
                  </li>
                  <li>
                    <span>{t("serviceManagementDocThemeInformationSubtaskDescriptionTitleFour")}:</span>
                    <ul>
                      <li>{t("serviceManagementDocThemeInformationSubtaskDescriptionTextSix")}</li>
                    </ul>
                  </li>
                </ul>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.explain}>{t("serviceManagementDocThemeInformationSubtaskDescriptionTwo")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', ['documentsTranslate', 'common'])),
    },
  };
};

export default ContentTheme;
